import React from 'react'
import Back from '../common/Back'
import TeamCard from './TeamCard'

const Team = () => {
    return (
        <>
            <Back title='Our Team'/>
            <TeamCard />
        </>
    )
}

export default Team
